import Client from 'mw-fetch';
import { call, put, select } from 'redux-saga/effects';
import {
  SHOW_NOTIFY,
  NOTIFY_LEVEL,
  SHOW_SESSION_MODAL,
  RequestStatus,
} from 'constants';
import AppUtils from '@control-front-end/utils/utils';
import apm from '../apm';

// Отображение ошибки
function* sendError({ message, method, url, body, statusCode }) {
  const auth = yield select((state) => state.auth);
  yield put({
    type: SHOW_NOTIFY.REQUEST,
    payload: {
      id: AppUtils.createRid(),
      type: NOTIFY_LEVEL.ERROR,
      label: message,
      statusCode,
    },
  });
  apm.addLabels({ errorType: statusCode });
  apm.setUserContext({
    id: auth.id,
    username: auth.nick,
  });
  apm.setCustomContext({ method, url, body, statusCode });
  apm.captureError(new Error(message));
}

// Сформировать строку авторизации
export function makeAuthHeader(appAuth) {
  const { udid, token } = appAuth;
  if (!udid && !token) return null;
  return btoa(unescape(encodeURIComponent(JSON.stringify({ udid, token }))));
}

function* getConnector(reqType) {
  const appAuth = yield select((state) => state.appAuth);
  const authStr = makeAuthHeader(appAuth);
  const authHeader = authStr ? { Authorization: `Bearer ${authStr}` } : {};
  if (reqType === 'multipart') {
    return new Client({
      headers: {
        'Content-Type': 'multipart/form-data',
        'Control-Tab-Id': appAuth.tabId,
        ...authHeader,
      },
    });
  }
  return new Client({
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Control-Tab-Id': appAuth.tabId,
      ...authHeader,
    },
  });
}

function* api({
  method = 'get',
  url = '',
  body = {},
  reqType = 'json',
  queryParams = {},
  handleErrCodes = [],
}) {
  if (!url) return;
  url = AppUtils.makeAppUrl(url, queryParams);
  let response = {};
  try {
    // Вызов АПИ
    const client = yield call(getConnector, reqType);
    response = yield call([client, method], url, body);
    // Парсинг результатов от api
    switch (response.result) {
      case RequestStatus.SUCCESS:
        break;
      case RequestStatus.ERROR:
        const throwError = !handleErrCodes.includes(response.data.statusCode);
        if (throwError) {
          yield sendError({
            message: response.data.message,
            method,
            url,
            body,
            statusCode: response.data.statusCode,
          });
        }
        break;
      case RequestStatus.UNAUTH:
        yield put({ type: SHOW_SESSION_MODAL });
        break;
      default:
        break;
    }
  } catch (e) {
    yield sendError({
      message: e.message,
      method,
      url,
      body,
      statusCode: '50X',
    });
  }

  return response;
}

export default api;
